import axios from 'axios';
import replaceCartContent from './replaceCartContent';

if (!customElements.get('add-to-cart')) {
  class AddToCart extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button');
      if (!this.button) return;

      this.enableAddToCart = this.button.dataset.hasOnlyDefaultVariant === 'true';
      this.productListInfo = this.closest('.product-list')?.querySelector('.product-list-info');
      this.spinner = this.button.querySelector('.add-to-cart-button-spinner');
      this.buttonText = this.button.querySelector('.add-to-cart-button-text');
      this.variantId = this.button.dataset.variantId;
      this.addToCartText = this.button.dataset.addToCartText;
      if (this.variantId) {
        this.button.addEventListener('click', this.handleButtonClick.bind(this));
      }
    }

    handleButtonClick(event) {
      event.preventDefault();
      if (this.enableAddToCart) {
        this.addToCart();
      } else {
        this.enableAddToCart = true;
        this.displayVariantSelector();
      }
    }

    async addToCart() {
      this.toggleLoadingState(true);
      try {
        await this.addVariantToCart();
        await replaceCartContent();
      } catch (error) {
        console.error('Error adding item to cart:', error);
      } finally {
        this.toggleLoadingState(false);
      }
    }

    async addVariantToCart() {
      return axios.post('/cart/add.js', {
        items: [{ id: this.variantId, quantity: 1 }],
      });
    }

    displayVariantSelector() {
      const template = this.querySelector('template');
      if (!template) return;

      const variantSelector = template.content?.querySelector('#select-product-variants-selector')?.cloneNode(true);
      if (variantSelector && this.productListInfo) {
        this.productListInfo.appendChild(variantSelector);
        variantSelector.addEventListener('change', this.handleVariantChange.bind(this));
        this.selectFirstAvailableVariant(variantSelector);
      }
    }

    selectFirstAvailableVariant(variantSelector) {
      const firstAvailable = Array.from(variantSelector.options).find((option) => option.dataset.available === 'true');
      if (firstAvailable) {
        this.variantId = firstAvailable.value;
        this.enableAddToCart = true;
        this.updateAddToCartButton();
      }
    }

    handleVariantChange(event) {
      this.variantId = event.target.value;
      this.updateAddToCartButton();
    }

    updateAddToCartButton() {
      if (this.variantId && this.enableAddToCart) {
        this.button.dataset.variantId = this.variantId;
        if (this.buttonText) {
          this.buttonText.textContent = this.addToCartText;
        }
      }
    }

    toggleLoadingState(isLoading) {
      if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
      if (this.buttonText) this.buttonText.classList.toggle('invisible', isLoading);
    }
  }

  customElements.define('add-to-cart', AddToCart);

  // Use MutationObserver to watch for new add-to-cart elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.querySelector('add-to-cart')) {
          new AddToCart(node.querySelector('add-to-cart'));
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
